import React from 'react';
import { Link } from 'react-router-dom';
import './Music.css';

const interestCategories = ['Football', 'Esports', 'People', 'Languages', 'Fitness', 'Music'];

const linkStyle: React.CSSProperties = { color: '#e50914', fontWeight: 600, textDecoration: 'none' };

const hobbies: {
  title: string;
  subtitle: string;
  description: string;
  emoji: string;
  link?: { label: string; url: string; internal?: boolean };
}[] = [
  {
    title: 'Football',
    subtitle: 'Visca Barça 🔵🔴',
    description: 'Huge football fan and a die-hard Barcelona supporter, both watching and playing',
    emoji: '⚽',
  },
  {
    title: 'Gaming and esports',
    subtitle: 'Playing + watching',
    description:
      'Crazy about gaming and esports, playing, watching and following the scene, deep enough to turn it into 5 years of international professional experience',
    emoji: '🎮',
  },
  {
    title: 'Meeting new people',
    subtitle: 'Real conversations',
    description:
      'I love talking to new people and making connections across tech, startups, esports and content creation, not just online networking but genuinely enjoying conversations with people from different worlds',
    emoji: '🤝',
    link: { label: "Let's connect on LinkedIn", url: 'https://www.linkedin.com/in/MKeshav04/' },
  },
  {
    title: 'Languages',
    subtitle: 'Currently Spanish',
    description: 'Learning Spanish, with more languages lined up after it',
    emoji: '🌍',
  },
  {
    title: 'Fitness',
    subtitle: 'Gym + jogging',
    description: 'Hitting the gym and jogging regularly, staying active keeps everything else running',
    emoji: '🏋️',
  },
  {
    title: 'Harmonica',
    subtitle: 'Kept going',
    description: 'Harmonica, picked it up randomly and kept going',
    emoji: '🎵',
  },
  {
    title: 'Styling',
    subtitle: 'Dressing up',
    description: 'I enjoy styling, getting dressed up and taking care of myself',
    emoji: '👔',
  },
  {
    title: 'Reading',
    subtitle: 'A growing collection',
    description: 'I read and keep a good collection of books',
    emoji: '📚',
    link: { label: "See what I'm reading", url: '/reading', internal: true },
  },
];

const Hobbies: React.FC = () => {
  return (
    <div className="music-page">
      <div className="quote">
        <p>Beyond the keyboard — what keeps me curious, competitive, and creative.</p>
      </div>

      <div className="genre-section">
        <h3>Explore by Interest</h3>
        <div className="genres">
          {interestCategories.map((category, index) => (
            <div key={index} className="genre-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <p>{category}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="albums-section">
        <h3>Hobbies & Interests</h3>
        <div className="albums">
          {hobbies.map((hobby, index) => (
            <div key={index} className="album-card" style={{ animationDelay: `${index * 0.3}s` }}>
              <div className="album-details" style={{ padding: '1.5rem', textAlign: 'center' }}>
                <h4 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>{hobby.emoji}</h4>
                <h4>{hobby.title}</h4>
                <p style={{ opacity: 0.8, marginBottom: '0.75rem' }}>{hobby.subtitle}</p>
                <p style={{ fontSize: '0.9rem', lineHeight: 1.5 }}>{hobby.description}</p>
                {hobby.link && (
                  <p style={{ marginTop: '0.75rem' }}>
                    {hobby.link.internal ? (
                      <Link to={hobby.link.url} style={linkStyle}>
                        {hobby.link.label} →
                      </Link>
                    ) : (
                      <a href={hobby.link.url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                        {hobby.link.label} →
                      </a>
                    )}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hobbies;
